import { Box, Stack, Text } from '@chakra-ui/react';
import { format } from 'date-fns';

import { IApplicationModel } from 'api/types/trueFileServerTypes';
import UserIcon from 'assets/icons/applicant-icon.svg';

interface ApplicationCardProps {
  app: IApplicationModel;
  onClick: ()=> void;
}

export function ApplicationCard({ app, onClick }: ApplicationCardProps): JSX.Element {
  const applicants = app.applicants ?? [];
  const names = applicants.map((a) => `${a.firstName} ${a.lastName}`.trim());

  const totalFiles = (app.files?.length ?? 0)
    + applicants.flatMap((a) => a.files ?? []).length;

  const createdDate = app.dateCreated
    ? format(new Date(app.dateCreated), 'MMM d, yyyy')
    : '';

  return (
    <Box
      bg='#F4F4F4'
      w='100%'
      borderRadius='20px 20px 20px 0'
      p='30px'
      mb='25px'
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      cursor='pointer'
      _hover={{ bg: '#E8E8E8' }}
      onClick={onClick}
    >
      <Stack spacing='12px'>
        {names.map((name) => (
          <Box
            key={name} display='flex'
            alignItems='center'
          >
            <Box
              as='img' src={UserIcon}
              alt='User' w='32px'
              h='32px' mr='8px'

            />
            <Text textTransform='capitalize'>{name}</Text>
          </Box>
        ))}
      </Stack>

      <Stack
        spacing='8px' textAlign='right'
        alignItems='flex-end'
      >
        <Text display='flex' alignItems='center'>
          <Box
            as='span' w='10px'
            h='10px' bg='#83B7FF'
            borderRadius='50%' mr='8px'
          />
          {totalFiles}
          {' '}
          File
          {totalFiles !== 1 && 's'}
        </Text>
        <Text color='gray.500'>{createdDate}</Text>
      </Stack>
    </Box>
  );
}
